<div class="card">
  <div class="card-header" style="border-bottom: none">
    <div
      class="card-title d-flex flex-row justify-content-between align-items-center"
    >
      <h4 style="margin: 0">{{ data.title }}</h4>
      <button
        *ngIf="data.close"
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="onClose()"
        style="font-size: 1.2rem"
      ></button>
    </div>
  </div>
  <div class="card-body">
    <div>
      Selected Filters - Segment: {{ filters?.cleaned_vertical }}, Platform:
      {{ filters?.final_em }}, Start Date: {{ filters?.start_date }}, End Date:
      {{ filters?.end_date }}
    </div>
    <div [id]="data.widgetId" style="height: 75vh" [hidden]="hasError"></div>
    <div>
      Projects with &lt;50K spends are classified as Business continuity
      projects
    </div>
    <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>
  </div>
</div>
